<dx-button text="{{ 'button.refresh' | translate }}" icon="refresh" [disabled]="buttonDisabled" (onClick)="onClick()"></dx-button>